import React from "react";

const YoutubeEmbedSimpleDuplicate = () => {
  const videos = [
    { id: "yuxvAdGmxNA", title: "Golden Ticket Omkara" },
    { id: "LJ1hQacZdSM", title: "Codename The Gateway" },
    { id: "_JSykPOw2e4", title: "Codename Bigspace" },
    { id: "oR8MJYHmdvc", title: "Siddhivinayak Homes" },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#741112] text-center mb-4">
            Mega Launches
          </h2>
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12">
            Redefining Mandate Sales Through Powerful Mega Launches
          </p>
        </div>

        {/* Responsive layout – 4 in one line on large screens */}
        <div className="flex sm:grid gap-6 sm:grid-cols-2 lg:grid-cols-4 overflow-x-auto sm:overflow-visible hide-scrollbar pb-4">
          {videos.map((video) => (
            <div key={video.id} className="min-w-[85%] sm:min-w-0 flex-shrink-0">
              <div className="bg-white rounded-lg shadow-md overflow-hidden h-full">
                <div className="relative aspect-video">
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${video.id}?rel=0`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-5 border-t border-slate-100 bg-gradient-to-br from-slate-50 to-blue-50">
                  <h3 className="text-lg font-semibold text-slate-800 text-center">
                    {video.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* YouTube Channel Button */}
        <div className="mt-12 flex justify-center">
          <a
            href="https://www.youtube.com/@realation6580"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#741112] hover:bg-[#5e0e0e] text-white font-semibold py-3 px-8 rounded-full transition"
          >
            View All Videos
          </a>
        </div>
      </div>
    </section>
  );
};

export default YoutubeEmbedSimpleDuplicate;
